

import React, { useState, useEffect, useContext } from "react";
import useSWR from "swr";
import { fetcher, commentsFetcher } from "../../utils/request";
import constants from "../../config/constants";
import CardSwitcher from "../cards/CardSwitcher";
import TopNav from "../layout/TopNav";
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';
import AppContext from "../AppContext";
import { trackPageView } from '../../utils/adobeAnalytics';
import ShareModal from "../common/ShareModal";
import Modal from "../common/Modal";
import FeedbackForm from "../layout/FeedbackForm";
import FeedbackSent from "../layout/FeedbackSent";
import Fragment from "../cards/common/Fragments";

export default function Sharedposts({ isAuthenticated, match, hasAccess, hasAccessUntil, isMember, userPermission, userId }) {
  let subStatus="";
  //https://localhost:44350/ "for local use"
  const { data: post } = useSWR(() =>
       `/SharedPosts/${match.params.contentKey}/${match.params.id}`,
    async (url) => {
      const res = await fetch(url, {

      });
      if (res.redirected) {
        window.location = res.url;
      }
      if (res.statusCode === 400) {
        throw new Error('A 400 error occurred while fetching the data.'); // Throw the error
      }

      return res.json();
    }
  );
  const swrOptions = {
    revalidateOnFocus: false,
    onError: (err, key, config) => {
        console.log("err list", err);
    },
    onSuccess: () => {        
    },
  };   
  const [feedbackModal, setFeedbackModal] = useState({
    visible: false,
    contentKey: "",
    sent: false,
  });
  const showFeedbackModal = ({ contentKey }) =>
    setFeedbackModal({ ...feedbackModal, visible: true, contentKey });

  const { data: getplaylistwithlikes } = useSWR(isAuthenticated ? "/api/playlist/getplaylistwithlikes" : null, fetcher, swrOptions);
  const { data: lookup } = useSWR(isAuthenticated ? "/api/lookup" : null, fetcher, swrOptions);
  const { data: feedbacks } = useSWR(isAuthenticated ? ["/api/Comment/Query", constants.commentTypes.feedback] : [], commentsFetcher);
  const userLikes = getplaylistwithlikes?.userLikes || [];
  const playlists = getplaylistwithlikes?.playlists || null;
  
   useEffect(() => {
 if (hasAccess && hasAccess == true) {
            if (isMember == true) {
                subStatus = "subscribed:pmi_membership"
            }
            else {
                subStatus = "subscribed:stdplus_subscription"
            }
        }
        else {
            subStatus = "Non-subscribed"
        }
    if (isAuthenticated) {
      let loginData = {
        event: 'loggedin',
        eventInfo: 'loggedin',
        user: {
          membershipTier: userPermission?.isMember?.membership,
          membershipStatus: userPermission?.isMember?.isMember == true ? 'active' : 'expired',
          pmiID: userId
        }
      }
      let subscriptionStatus = {
        event: "sd-app-load",
        eventInfo: "sd-app-load",
        sd: {
          renewalDate:hasAccessUntil.split('T')[0],
          subStatus: subStatus,

        }
      }
      pushDatatoAdobeLayer({ loginData, subscriptionStatus, status: isAuthenticated })
    }else{
 pushDatatoAdobeLayer({  status: isAuthenticated })
}
  }, []);
  const canProceed = () => {
    return true;
  };
  const [downloadedContentKeys, setDownloadedContentKeys] = useState([]);
  const [sharePost, setSharePost] = useState();
  const [isShareModalVisible, setIsShareModalVisible] = useState(false);
  const showShareModal = (post) => {
    setSharePost(post);
    setIsShareModalVisible(true);
  };
  const [pmbokModal, setPmbokModal] = useState({ visible: false, data: "" });
  const showPmbokModal = (data) => {
    document.querySelector("body").classList.add("overflow-hidden");
    setPmbokModal({ visible: true, data });
  };

  return (<div className="flex flex-col">
    <TopNav isAuthenticated={isAuthenticated} />
    <div className="container mx-auto px-4 mt-8">
      <div className="overflow-hidden">
        <div className="flex justify-center" style={{ marginTop: "110px" }}>
          <div className="w-full" style={{ maxWidth: "730px" }}>
            <CardSwitcher
              post={post}
              canProceed={canProceed}
              fullcard={true}
              propGroup={{
                downloadedContentKeys,
                setDownloadedContentKeys,
              }}
              userLikes={userLikes}
              playlists={playlists}
              isAuthenticated={isAuthenticated}
              showShareModal={showShareModal}
              showFeedbackModal={showFeedbackModal}
              lookup={lookup}
              showPmbokModal={showPmbokModal}
            />
            {isShareModalVisible && (
              <ShareModal
                post={sharePost}
                onClose={() => setIsShareModalVisible(false)}
              />
            )}
            {feedbackModal.visible && (
              <Modal
                onClose={() =>
                  setFeedbackModal({
                    ...feedbackModal,
                    visible: false,
                    contentKey: "",
                  })
                }
              >
                <FeedbackForm
                  contentKey={feedbackModal.contentKey}
                  feedbacks={feedbacks}
                  onSubmit={() =>
                    setFeedbackModal({
                      ...feedbackModal,
                      visible: false,
                      contentKey: "",
                      sent: true,
                    })
                  }
                />
              </Modal>
            )}
            {feedbackModal.sent && (
              <Modal
                onClose={() => setFeedbackModal({ ...feedbackModal, sent: false })}
              >
                <FeedbackSent
                  setModalVisible={() =>
                    setFeedbackModal({ ...feedbackModal, sent: false })
                  }
                />
              </Modal>
            )}
            {pmbokModal.visible && (
              <Modal onClose={() => setPmbokModal({ visible: false, data: "" })} onClickOutside={true}>
                <Fragment data={pmbokModal.data} />
              </Modal>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>);
}
